'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var stringify = function stringify(array) {
  return array && array.length && array.map(function (item, i) {
    return (item && item.name || item) + (i + 1 < array.length ? ', ' : '');
  });
};

exports.default = stringify;